import RockMapContainer from "./RockMapContainer";

export default RockMapContainer;